module.exports = __webpack_public_path__ + "img/gc_country_flag_es.5b8a40ba.svg";